(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    const announcementBar = document.querySelector('.custom-bar');
    const announcementBarClose = document.querySelector('.announcement-bar__close');

    if (announcementBar && announcementBarClose) {
      announcementBarClose.addEventListener('click', function () {
        announcementBar.style.display = 'none';
        if (document.querySelector('.template-index')) {
          document.querySelector('.header-wrapper').style.top = '0';
        }
        if (document.querySelector('.template-product')) {
          document.querySelector('.footer').removeAttribute('style');
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isCollection = document.querySelector('.template-collection');
      this.mobileMenuButton = this.querySelector('.mobile-menu__trigger');
      this.mobileMenuBody = this.querySelector('.mobile-menu__body');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.homeHeader();
      this.mobileMenu();
      this.initSearch();
      this.addStrikethroughHoverEffect();

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      // this.setQuickSearchHeight();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || this.isCollection) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      // this.setQuickSearchHeight();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      // this.setQuickSearchHeight();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    mobileMenu() {
      this.mobileMenuButton.addEventListener('click', () => {
        this.mobileMenuBody.classList.toggle('is-active');
        document.body.classList.toggle('mobile-menu-open');
        document.documentElement.classList.toggle('mobile-menu-open');
        if (this.mobileMenuBody.classList.contains('is-active')) {
          this.mobileMenuButton.querySelector('span').innerText = 'Close';
        } else {
          this.mobileMenuButton.querySelector('span').innerText = 'Menu';
        }
      });
    }

    homeHeader() {
      const home = document.querySelector('.template-index');
      if (home) {
        const indexHeader = document.querySelector('.header-wrapper');
        const customBar = document.querySelector('.custom-bar');
        let lastScrollTop = 0; // Add this line
        window.addEventListener('scroll', () => {
          let st = window.pageYOffset || document.documentElement.scrollTop;
          if (st > lastScrollTop) {
            // downscroll code
            if (window.scrollY > 100) {
              indexHeader.classList.remove('is-fixed-alt');
            }
          } else {
            // upscroll code
            indexHeader.classList.add('is-fixed-alt');
            if (window.scrollY < 100) {
              indexHeader.classList.remove('is-fixed-alt');
            }
          }
          lastScrollTop = st <= 0 ? 0 : st;
          if (window.scrollY > 100) {
            customBar.classList.add('is-fixed');
            indexHeader.classList.add('is-fixed');
          } else {
            customBar.classList.remove('is-fixed');
            indexHeader.classList.remove('is-fixed');
          }
        });
      }
    }

    initSearch() {
      if (window.innerWidth > 990) {
        document.querySelector('.mobile-menu .header__search').remove();
      }
      this.animetedLinks = this.querySelectorAll('.mobile-menu .animated-text .animated-item');
      this.searchForm = this.querySelector('.mobile-menu .search-modal__form form');
      const parentElement = this.querySelector('.mobile-menu');
      parentElement.addEventListener('click', (event) => {
        if (event.target && event.target.classList.contains('animated-item')) {
          this.searchForm.submit();
        }
      });
    }

    addStrikethroughHoverEffect() {
      document.addEventListener('DOMContentLoaded', function () {
        if (window.innerWidth > 990) {
          const parentElement = document.querySelector('.header__link-list');

          parentElement.addEventListener('mousemove', function (e) {
            if (e.target.tagName === 'A') {
              const parentLeftPos = parentElement.getBoundingClientRect().left;
              const rect = e.target.getBoundingClientRect();
              const width = rect.width;
              let leftPos = Math.abs(parentLeftPos - rect.left);

              document.body.style.setProperty('--position-left', `${leftPos}px`);
              document.body.style.setProperty('--link-width', `${width}px`);
            }
          });

          const headerAccounts = document.querySelector('.header__accounts');
          const headerAccountsTarget = document.querySelectorAll('.header__accounts [data-move-target]');
          const headerSearchBtn = document.querySelector('.header__accounts .header__icon--summary');
          headerAccountsTarget.forEach((target) => {
            target.addEventListener('mouseenter', function (e) {
              const parentLeftPos = headerAccounts.getBoundingClientRect().left;
              const rect = e.target.getBoundingClientRect();
              const width = rect.width;
              let leftPos = Math.abs(parentLeftPos - rect.left);

              document.body.style.setProperty('--position-left2', `${leftPos}px`);
              document.body.style.setProperty('--link-width2', `${width}px`);
            });
          });

          headerSearchBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            console.log(e.target);
            console.log(e.target.closest('.header__accounts'));
            e.target.closest('.header__accounts').classList.add('remove-relative');
          });
        }
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  let elem = document.querySelector('#collection-grid');
  let infScroll = new InfiniteScroll( elem, {
    // options
    path: '.pagination__item--prev',
    history: false,
    append: '#collection-grid .grid__item',
    button: '.view-more-button',
    scrollThreshold: false,
  });

  infScroll.on( 'append', function( body, path, items, response ) {
    items.forEach(function(item) {
      item.querySelector('.pixelated-effect').classList.add('visible');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-feed"] && !window.DesignMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', (event) => {
    // Get all product card content divs
    // const productCardContents = Array.from(document.querySelectorAll('.product-feed .product-card__content'));

    // // Get the maximum height
    // const maxHeight = Math.max(...productCardContents.map(div => div.offsetHeight));

    // // Set the height of all divs to the maximum height
    // productCardContents.forEach(div => div.style.height = `${maxHeight}px`);
});

  } catch(e) { console.error(e); }
})();
})();
